import _ from "lodash";

export const UtilFunctions = {
    difference: (object, base) => {
        if (object === base) return {};
        if (object === null && !!base) return base;
        if (!!object && base === null) return object;

        function changes(object, base) {
            return _.transform(object, function (result, value, key) {
                if (!_.isEqual(value, base[key])) {
                    result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
                }
            });
        }

        return changes(object, base);
    },
};
